import React, { useEffect, useCallback, useState } from "react";
import ModalProgresso from "../../../shared/components/ModalProgresso";
import ModalImpressaoApplet from "./ModalImpressaoApplet";
import EtiquetaImpressaoManager from "../EtiquetaImpressaoManager";
import ModalSelecionarConsevercao from "./ModalSelecionarConsevercao";

const ModalImpressao = ({
  modalAberto,
  setModalAberto,
  codigoLaboratorio,
  idLote,
  usaApplet,
  portaGti,
}) => {
  const [possuiTipoConservacao, setPossuiTipoConservacao] = useState(false);
  const [obtendoConservacao, setObtendoConservacao] = useState(true);

  const handleFecharModal = useCallback(() => {
    setModalAberto(false);
  }, [setModalAberto]);

  const modalImpressaoApplet = (
    <ModalImpressaoApplet
      modalAberto={modalAberto}
      fecharModal={handleFecharModal}
      codigoLaboratorio={codigoLaboratorio}
      idLote={idLote}
    />
  );

  const modalProgresso = (
    <ModalProgresso
      modalAberto={modalAberto}
      fecharModal={handleFecharModal}
      titulo="Pedido em Impressão"
    />
  );

  const modalSelecionarConsevercao = (
    <ModalSelecionarConsevercao
      modalAberto={modalAberto}
      fecharModal={handleFecharModal}
      idLote={idLote}
    />
  );

  const Imprimir = useCallback(async () => {
    const retorno = await EtiquetaImpressaoManager.possuiTipoConservacao(
      idLote
    );
    setPossuiTipoConservacao(retorno);
    setObtendoConservacao(false);
    if (retorno) {
      var dadosImpressao = await EtiquetaImpressaoManager.gerarEtiquetaImpressao(
        idLote
      );
      await EtiquetaImpressaoManager.enviarDadosParaImpressora(
        dadosImpressao,
        portaGti,
        usaApplet
      );
      handleFecharModal();
    }
    
  }, [idLote, portaGti, usaApplet, handleFecharModal]);

  useEffect(() => {
    if (modalAberto && idLote && !(usaApplet === "S")) {
      Imprimir();
    }
  }, [idLote, portaGti, usaApplet, modalAberto, Imprimir]);

  return (
    <>
      {!possuiTipoConservacao && obtendoConservacao && modalProgresso}
      {possuiTipoConservacao &&
        !obtendoConservacao &&
        usaApplet === "S" ? modalImpressaoApplet : modalProgresso}
      {!possuiTipoConservacao &&
        !obtendoConservacao &&
        modalSelecionarConsevercao}
    </>
  );
};

export default ModalImpressao;
